import { render } from "./dashboard-drawer.vue?vue&type=template&id=3e7284ae"
import script from "./dashboard-drawer.vue?vue&type=script&lang=js"
export * from "./dashboard-drawer.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\domin\\Desktop\\FIles\\front\\jauris\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__